const question = {
    free: { point: [2] },
    clause: { point: [1] },
};

export default question;
